import Button from "@material-ui/core/Button";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import "date-fns";
import { Form } from "../../base/views/useForm";
import React, { useEffect, useState } from "react";
import { editMasterProduct } from "../helper/masterProductHelper";

const useStyles = makeStyles((theme) => ({
  Appcss: {
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(6px)",
    borderRadius: "15px",
    padding: "30px",
    justifyContent: "center",
    alignItems: "center",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(1, 0, 2),
  },
}));

export default function MasterProductForm(props) {
  const classes = useStyles();
  const {
    recordForEdit,
    onPopupClose,
    pageNumber,
    pageSize,
    setIsEdited,
    search,
  } = props;
  const [masterProductData, setState] = useState({
    c_ndc: "",
    description: "",
    upc: "",
    level_1_pack_size: "",
    level_2_pack_size: "",
    level_3_pack_size: "",
    case_qty: "",
    generic_cd: "",
    generic_status: "",
    generic_seq_no: "",
    storage_temp: "",
    shape: "",
    color: "",
    imprints: "",
    uom: "",
    hazard: "",
  });

  useEffect(() => {
    if (recordForEdit != null) {
      setState({
        ...recordForEdit,
        search: search,
      });
    }
    // eslint-disable-next-line
  }, [recordForEdit, setState]);

  const saveMasterProduct = (e) => {
    e.preventDefault();
    let data = masterProductData;
    data.page_number = pageNumber;
    data.page_size = pageSize;
    editMasterProduct(data)
      .then((response) => {
        onPopupClose(false);
        setIsEdited(true);
      })
      .catch((err) => {});
  };

  const handleChange = (e) => {
    setState({
      ...masterProductData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <Form>
      <Container component="main" maxWidth="xl">
        <div className={classes.form}>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <TextField
                value={masterProductData.package_ndc}
                autoComplete="uid"
                name="package_ndc"
                variant="outlined"
                fullWidth
                id="package_ndc"
                label="Package NDC"
                onChange={handleChange}
                disabled
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                style={{ width: "90%" }}
                value={masterProductData.description}
                autoComplete="uid"
                name="description"
                variant="outlined"
                id="description"
                label="Description"
                onChange={handleChange}
                autoFocus
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                value={masterProductData.upc}
                autoComplete="uid"
                name="upc"
                variant="outlined"
                fullWidth
                id="upc"
                onChange={handleChange}
                label="UPC"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                value={masterProductData.c_ndc}
                autoComplete="uid"
                name="c_ndc"
                variant="outlined"
                fullWidth
                id="ndc"
                onChange={handleChange}
                label="NDC"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                value={masterProductData.level_1_pack_size}
                autoComplete="uid"
                name="level_1_pack_size"
                variant="outlined"
                fullWidth
                onChange={handleChange}
                id="level_1_pack_size"
                label="Level 1 Pack Size"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                value={masterProductData.level_2_pack_size}
                autoComplete="uid"
                name="level_2_pack_size"
                variant="outlined"
                fullWidth
                id="level_2_pack_size"
                onChange={handleChange}
                label="Level 2 Pack Size"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                value={masterProductData.level_3_pack_size}
                autoComplete="uid"
                name="level_3_pack_size"
                variant="outlined"
                fullWidth
                id="level_3_pack_size"
                onChange={handleChange}
                label="Level 3 Pack Size"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                value={masterProductData.case_qty}
                autoComplete="uid"
                name="case_qty"
                variant="outlined"
                fullWidth
                id="case_qty"
                onChange={handleChange}
                label="Case Qty"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                value={masterProductData.generic_cd}
                autoComplete="uid"
                name="generic_cd"
                variant="outlined"
                fullWidth
                id="generic_cd"
                label="Generic_Cd"
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                value={masterProductData.generic_status}
                autoComplete="uid"
                name="generic_status"
                variant="outlined"
                fullWidth
                id="generic_status"
                label="Generic Status"
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                value={masterProductData.generic_seq_no}
                autoComplete="uid"
                name="generic_seq_no"
                variant="outlined"
                fullWidth
                id="generic_seq_no"
                label="Generic Seq No"
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                value={masterProductData.storage_temp}
                autoComplete="uid"
                name="storage_temp"
                variant="outlined"
                fullWidth
                id="storage_temp"
                label="Storage Temp"
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                value={masterProductData.shape}
                autoComplete="uid"
                name="shape"
                variant="outlined"
                fullWidth
                id="shape"
                label="Shape"
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                value={masterProductData.color}
                autoComplete="uid"
                name="color"
                variant="outlined"
                fullWidth
                id="color"
                label="Color"
                onChange={handleChange}
              />
            </Grid>
          </Grid>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Button
              fullWidth
              type="submit"
              variant="contained"
              color="primary"
              className={classes.submit}
              onClick={saveMasterProduct}
              style={{ width: "20vw" }}
            >
              Save
            </Button>
          </div>
        </div>
      </Container>
    </Form>
  );
}
